export default {
  unavailableWarningTitle: 'Scheduled maintenance period',
  unavailableMessageTitle: 'System maintenance',
  unavailableWarning: 'Please note that our systems will be unavailable on {{date}}, due to scheduled maintenance. We apologize for any inconvenience this may cause you.',
  unavailableMessage: 'Please note that our systems are currently unavailable. We apologize for any inconvenience this may cause you.',
  unavailableEndDate: '</br>Our systems will be available again on {{date}}',
  from: 'from',
  to: 'to',
  at: 'at',
};
